import React, { Component } from 'react'
import Img from 'gatsby-image'
import './style.sass'
import MailchimpSubscribe from '../mailchimp-subscribe'

export default class Footer extends Component {
  url =
    '//gmail.us3.list-manage.com/subscribe/post?u=597aeb67cd80e2cc2ff8699d1&amp;id=c2b067fddd'

  render() {
    const { images } = this.props

    const logoStudiUmanistici = images.find(
      image => image.node.sizes.src.indexOf('logo-studi-umanistici') >= 0
    )
    const logoUsi = images.find(
      image => image.node.sizes.src.indexOf('logo-usi') >= 0
    )
    const logoAdm = images.find(
      image => image.node.sizes.src.indexOf('logo-adm') >= 0
    )
    const logoPadova = images.find(
      image => image.node.sizes.src.indexOf('logo-padova') >= 0
    )
    const logoSiena = images.find(
      image => image.node.sizes.src.indexOf('logo-siena') >= 0
    )
    const logoNormale = images.find(
      image => image.node.sizes.src.indexOf('logo-normale') >= 0
    )
    const logoTorVergata = images.find(
      image => image.node.sizes.src.indexOf('logo-tor-vergata') >= 0
    )

    return (
      <footer className="Footer">
        <div className="Footer__Mobile">
          <div className="Footer__Section--mobile">
            <div className="Footer__Mobile__Row">
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoUsi.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoAdm.node.sizes} />
              </div>
            </div>
            <div className="Footer__Mobile__Row">
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoStudiUmanistici.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoPadova.node.sizes} />
              </div>
            </div>

            <div className="Footer__Mobile__Row">
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoSiena.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoNormale.node.sizes} />
              </div>
            </div>
            <div className="Footer__Mobile__Row">
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoTorVergata.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 1 }} />
            </div>
          </div>
          <div className="Footer__Section--mobile">
            <div
              style={{
                margin: '0 auto',
                width: '300px',
              }}
            >
              <div className="Footer__Heading">Contatti</div>

              <div className="text-white">
                <div>Mail: centrostudi.stucco@gmail.com</div>
                <div>Telefono: + 4 1 58 666 55 00</div>
                <div>Via Magazzini Generali 14</div>
                <div>6828 Balerna (Svizzera)</div>
              </div>
            </div>
          </div>

          <div className="Footer__Section--mobile">
            <div
              style={{
                margin: '0 auto',
                width: '300px',
              }}
            >
              <div className="Footer__Right SubscribeForm">
                <div className="Footer__Heading">Iscriviti alla newsletter</div>
                <MailchimpSubscribe url={this.url} />
              </div>
            </div>
          </div>
        </div>

        <div className="Footer__Desktop">
          <div className="Footer__Section">
            <div className="wrap-narrower Footer__LoghiPrimaRiga">
              <div className="LogoPrimaRiga" style={{ flex: 2 }}>
                <Img
                  sizes={logoUsi.node.sizes}
                  imgStyle={{
                    bottom: 0,
                    top: 'auto',
                    width: 'auto',
                  }}
                />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 1 }}>
                <Img sizes={logoAdm.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 2 }}>
                <Img
                  sizes={logoStudiUmanistici.node.sizes}
                  imgStyle={{
                    width: '90%',
                    height: 'auto',
                  }}
                />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                <Img sizes={logoPadova.node.sizes} />
              </div>
            </div>

            <div className="wrap-narrower Footer__LoghiPrimaRiga">
              <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                <Img sizes={logoSiena.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 2 }}>
                <Img sizes={logoNormale.node.sizes} />
              </div>
              <div className="LogoPrimaRiga" style={{ flex: 3 }}>
                <Img sizes={logoTorVergata.node.sizes} />
              </div>
            </div>
          </div>

          <div className="Footer__Section">
            <div className="wrap-narrower">
              <div className="Footer__Row">
                <div className="Footer__Left">
                  <div className="Footer__Heading">Contatti</div>

                  <div className="text-white">
                    <div>Mail: centrostudi.stucco@gmail.com</div>
                    <div>Telefono: + 4 1 58 666 55 00</div>
                    <div>Via Magazzini Generali 14</div>
                    <div>6828 Balerna (Svizzera)</div>
                  </div>
                </div>
                <div className="Footer__Right SubscribeForm">
                  <div className="Footer__Heading">
                    Iscriviti alla newsletter
                  </div>
                  <MailchimpSubscribe url={this.url} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js